<div class="flat-rate sub-item" [ngClass]="{'new-service-item': false}">

  <!-- Item Type -->
  <div class="item type">
    <app-auto-complete name="item-type-{{itemIndex}}" field="label" highlightField="highlightField"
      styleClassInputWrapper="pl-0" styleClassInput="p-6p pl-0" styleClassListWrapper="top-38"
      styleClassError="top-35 left-10" inactiveItemsKey="value" itemWidth="150px" scrollHeight="210px"
      placeholder="Select *" id="item-type-{{itemIndex}}" listId="item-type-list-{{itemIndex}}"
      [leftIcon]="subItem.type === 'partLookUp' ? 'mr-2 lookup-image-item' : ''" [selectTextOnFocus]="true" [delay]="10"
      [hasBorderBottomOnActive]="errors?.type" [minSearchLength]="1" [theme]="errors?.type? 'primary' : 'light'"
      [value]="itemTypeLabel[subItem?.type]" [suggestions]="itemTypeSuggestions" [isDropdownIconVisible]="true"
      [selectionOnTab]="true" [highlightFirstSelectedValue]="true" (appSelect)="handleSelect('type', $event?.value)"
      (appFocus)="handleFocus('type')" (appEnter)="handleBlur('type')" (appBlur)="handleBlur('type')"
      (appTabPress)="handleBlur('type')" (appCompletedMethod)="handleItemTypeSearch($event)"
      (appBlur)="handleBlur('type')" (appClear)="handleClear('type')">
      <ng-template appTemplate="item" let-item let-query="query">
        <!-- [innerHTML]="highlighedSearchText(item?.label, query)" -->
        <div class="item-list" [ngClass]="{'item-disabled not-allowed': subItem?.itemId}">
          {{ item.label }}
          <span class="ml-1 lookup-image-dropdown-item" *ngIf="item.value === 'partLookUp'"> </span>
        </div>
      </ng-template>
    </app-auto-complete>
  </div>

  <!-- Item Name -->
  <div class="item partService" [ngClass]="{ 'parts-lookup': subItem?.type === 'partLookUp' }">
    <div *ngIf="subItem?.type === 'other' else searchableItem">
      <app-input styleClassInput="p-6p pl-0" styleClassInputWrapper="pl-0" styleClassError="top-35 left-10"
        [theme]="errors?.title? 'primary' : 'light'" [placeholder]="itemTypePlaceholder[subItem?.type]"
        [hasBorderBottomOnActive]="errors?.title" [value]="subItem?.title" [isInvalid]="errors?.title" [fontSize]="12"
        (appChange)="handleChange('title', $event)" (appFocus)="handleFocus('title')">
      </app-input>
    </div>

    <ng-template #searchableItem>
      <app-auto-complete styleClassInput="p-6p pl-0 h-33px" styleClassInputWrapper="pl-0" styleClassListWrapper="top-38"
        styleClassError="top-35 left-10" itemWidth="300px" inactiveItemsKey="status" scrollHeight="184px"
        [theme]="errors?.title? 'primary' : 'light'" [placeholder]="itemTypePlaceholder[subItem?.type]"
        [isLoading]="isSearching" [allowMultiline]="!focus?.title" [maxAutoGrowHeight]="96"
        textAreaId="IT{{subItem?.itemId}}{{itemIndex}}" [showDisabledIcon]="false" [selectionOnTab]="true"
        [autoFocus]="focus?.title" [selectInactiveItems]="false" [hasBorderBottomOnActive]="errors?.title"
        [isDropdownIconVisible]="true"
        [value]="currentLang === 'fr' ? ( subItem?.titleFR || subItem?.title || '' ) : ( subItem?.title || subItem?.titleFR || '' )"
        [fontSize]="12" [suggestions]="itemSuggestions" [isInvalid]="errors?.title" [isDropdownIconVisible]="true"
        [closeOnSelection]="true" (appFocus)="handleFocus('title')" (appClickOutside)="handleBlur('title')"
        (appSelect)="handleSelect('title', $event)" (appClear)="handleClear('title')"
        (appCompletedMethod)="handleItemSearch($event)">
        <ng-template let-item let-query="query" appTemplate="item">
          <div *ngIf="subItem?.type !== 'partLookUp'" class="flex-between-center"
            [ngClass]="{'disabled': !item?.status}">
            <div class="flex-start-center width-60p">
              <div class="flex-center-center mr-2">
                <i class="{{itemTypeIcons[subItem?.type]}} font-gray-75"></i>
              </div>

              <div class="flex-column flex-center-start service-item-details">
                <span class="flex-start-center font-secondary-700 font-600 width-100p text-truncate">
                  <!-- <span *ngIf="item?.code && item?.type !== 'tire'">{{item?.code}}&nbsp;-</span> -->
                  <div class="text-truncate font-12" *ngIf="!companyLocalization"
                    [innerHTML]="highlighedSearchText(item?.itemTitle, query)"></div>
                  <div class="text-truncate font-12" *ngIf="companyLocalization && item.searchBy === 'titleFR'"
                    [innerHTML]="highlighedSearchText(item?.itemTitleFR, query)"></div>
                  <div class="text-truncate font-12" *ngIf="companyLocalization && item.searchBy === 'title'"
                    [innerHTML]="highlighedSearchText(item?.itemTitle, query)"></div>
                </span>

                <span class="font-11 font-gray-55 tire-description text-truncate" [pTooltip]="item?.notes"
                  *ngIf="!companyLocalization" tooltipPosition="top"
                  tooltipStyleClass="list-tooltip limit-tooltip-text">
                  {{item?.notes || 'No description'}}
                </span>
                <span class="font-11 font-gray-55 tire-description text-truncate" [pTooltip]="item?.notes"
                  *ngIf="companyLocalization && item.searchBy === 'title'" tooltipPosition="top"
                  tooltipStyleClass="list-tooltip limit-tooltip-text">
                  {{item?.notes || 'No description'}}
                </span>
                <span class="font-11 font-gray-55 tire-description text-truncate" [pTooltip]="item?.descriptionFR"
                  *ngIf="companyLocalization && item.searchBy === 'titleFR'" tooltipPosition="top"
                  tooltipStyleClass="list-tooltip limit-tooltip-text">
                  {{item?.descriptionFR || 'No description'}}
                </span>
              </div>
            </div>

            <div class="flex-end-center width-30p">
              <div class="flex-column width-100p">
                <div class="font-secondary-700 flex-between-center">
                  <span class="font-600">Price</span>
                  <span class="font-600">&nbsp;{{item?.price | currency: usd}}</span>
                </div>
                <div class="font-11 font-gray-55 flex-between-center">
                  <span>Cost</span>
                  <span>&nbsp;{{item?.cost | currency: usd}}</span>
                </div>
              </div>
            </div>
          </div>
          <div *ngIf="subItem?.type === 'partLookUp'">
            {{ item?.name }}
          </div>
        </ng-template>
      </app-auto-complete>
    </ng-template>
  </div>

  <!-- Item Description -->
  <div class="item description">
    <app-textarea placeholder="Enter description" styleClassInput="pl-0" styleClass="pl-0" textAreaId="IT{{itemIndex}}"
      [maxLength]="1000" [selectTextOnFocus]="true" [rows]="1" [autoGrow]="true" [maxAutoGrowHeight]="96"
      [theme]="(focus?.description)? 'primary': 'light'" [fontSize]="12"
      [value]="currentLang === 'fr'? subItem?.descriptionFR  : subItem?.description" [autoFocus]="focus?.description"
      (appChange)="handleChange('description', $event)" (appFocus)="handleFocus('description')"
      (appBlur)="handleBlur('description')">
    </app-textarea>
  </div>

  <!-- Item Unit/Cost-->
  <div class="item unitcost">
    <app-input *ngIf="subItem?.type !== 'labor'" placeholder="$0.00" styleClassInputWrapper="pl-0 text-right"
      styleClassInput="p-6p pl-0 text-right" [allowDecimal]="focus?.cost? true: false"
      [theme]="focus?.cost? 'light' : 'light'" [hasBorderBottomOnActive]="false" [selectTextOnFocus]="true"
      [fontSize]="12" [disabled]="subItem?.type === 'hazmatFee' && subItem?.isPassThroughTax"
      [value]="focus?.cost? subItem.cost : subItem.cost | currency: usd" [autoFocus]="focus?.cost"
      (appChange)="handleChange('cost', $event)" (appFocus)="handleFocus('cost')" (appBlur)="handleBlur('cost')">
    </app-input>

    <app-input *ngIf="subItem?.type === 'labor'" placeholder="$0.00" styleClassInputWrapper="pl-0 text-right"
      styleClassInput="p-6p pl-0 text-right" [allowDecimal]="focus?.cost? true: false"
      [theme]="focus?.cost? 'light' : 'light'" [hasBorderBottomOnActive]="false" pTooltip="Labor cost rate"
      tooltipPosition="top" tooltipStyleClass="list-tooltip" [selectTextOnFocus]="true" [fontSize]="12"
      [value]="focus?.cost? subItem.cost : subItem.cost | currency: usd" [autoFocus]="focus?.cost"
      (appChange)="handleChange('cost', $event)" (appFocus)="handleFocus('cost')" (appBlur)="handleBlur('cost')">
    </app-input>


  </div>

  <!-- Service Unit/Price -->
  <div class="item unitprice">
    <app-input placeholder="$0.00" styleClassInputWrapper="pl-0 text-right" styleClassInput="p-6p pl-0 text-right"
      [theme]="focus?.price? 'light' : 'light'" [allowDecimal]="focus?.price" [hasBorderBottomOnActive]="false"
      [selectTextOnFocus]="true" [fontSize]="12" [autoFocus]="focus?.price"
      [value]="focus?.price? subItem.price : subItem.price | currency: usd" (appChange)="handleChange('price', $event)"
      (appFocus)="handleFocus('price')" (appBlur)="handleBlur('price')">
    </app-input>
  </div>

  <!-- Service Quantity -->
  <div class="item quantity">
    <app-input *ngIf="subItem?.type === 'tire'" styleClassInputWrapper="pl-0 text-right"
      styleClassInput="p-6p text-right" placeholder="0" [allowDecimal]="true" [selectTextOnFocus]="true"
      [theme]="focus?.count? 'light' : 'light'" [hasBorderBottomOnActive]="false" [fontSize]="12"
      [autoFocus]="focus.count" [value]="focus.count? subItem.count : subItem.count | number: '1.2-2'"
      (appFocus)="handleFocus('count')" (appBlur)="handleBlur('count')" (appKeyUp)="handleChange('count', $event)">
    </app-input>

    <app-input *ngIf="!subItem.type || ['other', 'part', 'hazmatFee', 'partLookUp'].includes(subItem?.type)"
      styleClassInputWrapper="pl-0 text-right" styleClassInput="p-6p text-right" placeholder="0" [fontSize]="12"
      [theme]="focus?.count? 'light' : 'light'" [autoFocus]="focus.count" [selectTextOnFocus]="true"
      [hasBorderBottomOnActive]="false" [value]="focus.count? subItem?.count : subItem?.count | number: '1.2-2'"
      mask="0*.99" (appFocus)="handleFocus('count')" (appBlur)="handleBlur('count')"
      (appKeyUp)="handleChange('count', $event)">
    </app-input>

    <app-input *ngIf="subItem.type === 'labor'" styleClassInputWrapper="pl-0 text-right"
      styleClassInput="p-6p text-right" placeholder="0" [fontSize]="12"
      [theme]="focus?.costEstimatedHours? 'light' : 'light'" [autoFocus]="focus.costEstimatedHours"
      [selectTextOnFocus]="true" [hasBorderBottomOnActive]="false"
      [value]="focus.costEstimatedHours? subItem?.costEstimatedHours : subItem?.costEstimatedHours | number: '1.2-2'"
      [pTooltip]="'Estimated hours = ' + (subItem?.costEstimatedHours | number: '1.2-2') + ' hrs\n' + 'Billable hours = ' + (subItem?.count | number: '1.2-2') + ' hrs'"
      tooltipPosition="top" tooltipStyleClass="list-tooltip" mask="0*.99" (appFocus)="handleFocus('costEstimatedHours')"
      (appBlur)="handleBlur('costEstimatedHours')" (appKeyUp)="handleChange('costEstimatedHours', $event);handleChange('count', $event)">
    </app-input>
  </div>

  <!-- Total Cost -->
  <div class="item cost">
    <app-input *ngIf="subItem?.type !== 'labor'" [allowDecimal]="focus?.totalCost? true: false" theme="light"
      placeholder="$0.00" styleClass="" styleClassInputWrapper=" text-right" styleClassInput="p-6p text-right"
      [selectTextOnFocus]="true" [fontSize]="12" [value]="subItem.totalCost | currency: usd" [disabled]="true">
    </app-input>

    <app-input *ngIf="subItem?.type === 'labor'" [allowDecimal]="focus?.totalCost? true: false" theme="light"
      placeholder="$0.00" styleClass="" styleClassInputWrapper="text-right" pTooltip="Labor cost rate * estimated hours"
      tooltipPosition="top" tooltipStyleClass="list-tooltip" styleClassInput="p-6p text-right"
      [selectTextOnFocus]="true" [fontSize]="12" [value]="subItem.totalCost | currency: usd" [disabled]="true">
    </app-input>

  </div>

  <!-- Total Price -->
  <div class="item netamount">
    <app-input theme="light" placeholder="$0.00" styleClass="text-right" styleClassInputWrapper="text-right"
      styleClassInput="p-6p" [selectTextOnFocus]="true" [fontSize]="12" [allowDecimal]="focus?.netSubtotal"
      [value]="subItem?.netSubtotal | currency: usd" [disabled]="true">
    </app-input>
  </div>

  <!-- Flat Rate -->
  <div class="item flatrate">
    <app-input theme="light" placeholder="$0.00" styleClass="text-right" styleClassInputWrapper="text-right"
      styleClassInput="p-6p text-right" [allowDecimal]="focus?.flatRateAmount" [selectTextOnFocus]="true"
      [fontSize]="12" [value]="subItem?.flatRateAmount | currency: usd" [disabled]="true">
    </app-input>
  </div>

  <div class="item">
    <div class="icons flex-start-center" [ngClass]="{'invisible': isLast}">
      <i class="fal fa-trash p-1 mr-2 pointer" (click)="handleDelete()"></i>

      <i class="fal fa-sack-dollar p-1 mr-2 pointer" tooltipPosition="bottom"
        tooltipStyleClass="flat-rate tooltip-width-500" [pTooltip]="subItem?.tooltip" [escape]="false"></i>

      <app-content-overlay right="26px" top="-10px" arrowTop="-6px" arrowRight="13px" [dropshadow]="false"
        [showArrow]="false">
        <ng-template appTemplate="item">
          <span class="p-1 mr-2 pointer">
            <i class="far fa-ellipsis-v"></i>
          </span>
        </ng-template>


        <ng-template appTemplate="overlay" let-close="close">
          <div class="flat-rate-detail-overlay">
            <div class="overlay-header">
              <span class="font-600">More details</span>
            </div>

            <div class="overlay-body mt-3">
              <div>
                <app-auto-complete id="flat-rate-{{itemIndex}}" listId="flat-rate-list-{{itemIndex}}"
                  placeholder="Supplier*" label="Supplier*" theme="primary" field="name" scrollHeight="180px"
                  editableItemIdKey="_id" vPosition="bottom" editFieldLabel="Create Supplier"
                  [hasStaticUnassignedFiled]="false" [fontSize]="14" [listItemFontSize]="12" [selectTextOnFocus]="true"
                  [hasFutureSelectionField]="false" [floatingLabel]="true" [listItemFontSize]="14"
                  [isDropdownIconVisible]="true" [autoFocus]="focus?.supplier" [suggestions]="suppliersResults"
                  [closeOnSelection]="true" [hasEditableField]="true" [value]="moreDetails?.supplier?.name || ''"
                  (appSelect)="handleMoreDetailChange('supplier', $event)" (appSave)="handleSaveSupplier($event)"
                  (appCompletedMethod)="handleSearch('supplier', $event)" (appUpdateItem)="handleUpdateSupplier($event)"
                  (appClear)="handleSearch('supplier', '')">
                  <ng-template let-item let-editItem="editItem" appTemplate="item">
                    <div class="tag-item flex-between-center">
                      <span class="font-14">{{ item?.name }}</span>

                      <div class="tag-item-action flex-end-center">
                        <i class="fas fa-pencil p-1 mr-2" (click)="$event.stopPropagation(); editItem(item)"></i>
                      </div>
                    </div>
                  </ng-template>
                </app-auto-complete>
              </div>

              <div class="flex-between-center mt-2">
                <span>Taxable</span>
                <app-switch-pill id="flat-sub-taxable-{{itemIndex}}" label="" position="end"
                  styleClassLabel="font-gray-35" [isActive]="moreDetails.isTaxable"
                  [disabled]="subItem?.isPassThroughTax" [fontSize]="12"
                  (appChange)="handleMoreDetailChange('isTaxable', $event)">
                </app-switch-pill>
              </div>

              <div *ngIf="isCommissionPlanEnabled" class="flex-between-center mt-2">
                <span>Commissionable</span>
                <app-switch-pill id="flat-sub-commissionable-{{itemIndex}}" label="" position="end"
                  styleClassLabel="font-gray-35" [isActive]="moreDetails.commissionable"
                  [disabled]="subItem?.isPassThroughTax" [fontSize]="12"
                  (appChange)="handleMoreDetailChange('commissionable', $event)">
                </app-switch-pill>
              </div>

              <div class="flex-between-center mt-2">
                <span>Display qty. on estimate & invoice</span>
                <app-switch-pill id="flat-sub-displayHoursOnOrder-{{itemIndex}}" label="" position="end"
                  styleClassLabel="font-gray-35" [isActive]="moreDetails.displayHoursOnOrder" [fontSize]="12"
                  (appChange)="handleMoreDetailChange('displayHoursOnOrder', $event)">
                </app-switch-pill>
              </div>

              <div class="flex-between-center mt-2">
                <span>Display desc. on estimate & invoice</span>
                <app-switch-pill id="flat-sub-displayDescOnOrder-{{itemIndex}}" label="" position="end"
                  styleClassLabel="font-gray-35" [isActive]="moreDetails.displayDescOnOrder" [fontSize]="12"
                  (appChange)="handleMoreDetailChange('displayDescOnOrder', $event)">
                </app-switch-pill>
              </div>
            </div>


            <div class="overlay-footer flex-end-center">
              <div class="btn btn-white mr-2" (click)="handleDetailsCancel(close)">Cancel</div>
              <div class="btn btn-primary" (click)="handleDetailsSave(close)">Save</div>
            </div>
          </div>
        </ng-template>
      </app-content-overlay>
    </div>
  </div>
</div>
